<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="[
        'Período Movimento',
        'Descrição',
        'Nível Risco',
        'Nível Risco Desc.',
        'Modalidade Bacen',
        'Sub Modal. Bacen',
        'Val. Vencer 30',
        'Val. Vencer 31 a 60',
        'Val. Vencer Prazo Indeterminado',
        'Val. Vencer 360',
        'Val. Vencer Acima 360',
        'Val. Vencer Total',
        'Val. Coobrigacao',
        'Val. Prejuízo',
        'Val. Devedor',
        'Val. Vencido 90',
        'Val. Vencido Acima 90',
        'Val. Vencido Total'
      ]"
      :showTipFooter="false"
      v-on:Load="onLoad"
    >
      <tr
        v-for="obj in this.objList"
        v-bind:key="obj.id"
      >
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.periodoMovimento ? formatPeriod(obj.periodoMovimento) : ''
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.nome"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.nivelRisco"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.nivelRiscoDescricao"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.modalidadeBacen"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="obj.subModalidadeBacen"
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valSicoobVencer30
              ? formatValue(obj.valSicoobVencer30)
              : 'R$ 0,00'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valSicoobVencer31a60
              ? formatValue(obj.valSicoobVencer31a60)
              : 'R$ 0,00'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valSicoobVencerPrazoIndeterminado
              ? formatValue(obj.valSicoobVencerPrazoIndeterminado)
              : 'R$ 0,00'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valSicoobVencer360
              ? formatValue(obj.valSicoobVencer360)
              : 'R$ 0,00'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valSicoobVencerAcima360
              ? formatValue(obj.valSicoobVencerAcima360)
              : 'R$ 0,00'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valSicoobVencerTotal
              ? formatValue(obj.valSicoobVencerTotal)
              : 'R$ 0,00'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valSicoobCoobrigacao
              ? formatValue(obj.valSicoobCoobrigacao)
              : 'R$ 0,00'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valSicoobPrejuizo
              ? formatValue(obj.valSicoobPrejuizo)
              : 'R$ 0,00'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valSicoobDevedor ? formatValue(obj.valSicoobDevedor) : 'R$ 0,00'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valSicoobVencido90
              ? formatValue(obj.valSicoobVencido90)
              : 'R$ 0,00'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valSicoobVencidoAcima90
              ? formatValue(obj.valSicoobVencidoAcima90)
              : 'R$ 0,00'
          "
        />
        <TableColumn
          :IsText="true"
          :status="1"
          :value="
            obj.valSicoobVencidoTotal
              ? formatValue(obj.valSicoobVencidoTotal)
              : 'R$ 0,00'
          "
        />
      </tr>
    </Tables>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import IndebtednessRepository from '@/shared/http/repositories/business/indebtedness.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'Indebtedness',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadIndebtedness(this.document)
      }
    },
    onLoadIndebtedness (document) {
      loading.push()
      this.document = document
      IndebtednessRepository.SearchEndvidamento(
        document,
        this.$refs.tableGrid.pagingLimit,
        this.$refs.tableGrid.pagingIndex
      )
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    },
    formatPeriod (value) {
      let result
      if (value) {
        result = value.substring(5, 7) + '/' + value.substring(0, 4)
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/IndebtednessSicoob.vue